export const SDRoutes = {
    Home: { path: '/' },
    About: { path: '/about' },
    Contact: { path: '/contact' },
    Blogs: { path: '/blogs' },
    Login: { path: '/login' },
    Register: { path: '/register' },
    ForgotPassword: { path: '/forgot-password' },
    Shop: { path: '/shop' },
    WellnessCenter: { path: '/wellness-center' },
    RadiologyServices: { path: '/radiology-services' },
    LaboratoryServices: { path: '/laboratory-services' },
    CovidTesting: { path: '/covid-testing' },
    PatientDashboard: { path: '/patient-dashboard' },
    PatientProfile: { path: '/patient-profile' },
    Appointment: { path: '/create-appointment' },
    ShoppingCart: { path: '/shopping-cart' },
    Checkout: { path: '/checkout' },
    BlogDetails: { path: '/blog-details/:id' },
    ServiceDetails: { path: '/service-details' },
    Dashboard: { path: '/admin/dashboard' },
    Patients: { path: '/admin/patients' },
    Appointments: { path: '/admin/appointments' },
    Doctors: { path: '/admin/doctors' },
    Services: { path: '/admin/services' },
    PatientVisits: { path: '/admin/patient-visits' },
    PatientLogs: { path: '/admin/patient-logs' },
    Orders: { path: '/admin/orders' },
    adminLogin: { path: '/admin' },
    adminRegister: { path: '/admin/register' },
    adminForgotPassword: { path: '/admin/forgot-password' },
}